// Function to load related data based on diocese ID
function loadRelatedData(dioceseId) {
  const $prerequisiteAssessmentSelect = $("#prerequisite_assessment_select");
  const $certificationAssessmentSelect = $("#certification_assessment_select");
  const $settingsSelect = $("#settings_select");

  if (dioceseId) {
    $.ajax({
      url: "/admin/pcc_assessments/related_data",
      method: "GET",
      data: { diocese_id: dioceseId },
      success: function (data) {
        $prerequisiteAssessmentSelect.html('<option value="">Select an assessment</option>');
        $.each(data.prerequisite_assessments, function (index, assessment) {
          $prerequisiteAssessmentSelect.append(
            `<option value="${assessment.id}">${assessment.name}</option>`
          );
        });
        $prerequisiteAssessmentSelect.prop("disabled", false).removeClass("disabled");

        $certificationAssessmentSelect.html('<option value="">Select an assessment</option>');
        $.each(data.certification_assessments, function (index, assessment) {
          $certificationAssessmentSelect.append(
            `<option value="${assessment.id}">${assessment.name}</option>`
          );
        });
        $certificationAssessmentSelect.prop("disabled", false).removeClass("disabled");

        $settingsSelect.html('<option value="">Select a configuration</option>');
        $.each(data.settings, function (index, setting) {
          $settingsSelect.append(
            `<option value="${setting.id}">${setting.name}</option>`
          );
        });
        $settingsSelect.prop("disabled", false).removeClass("disabled");
      },
      error: function (xhr) {
        console.error("Error fetching data:", xhr.responseText);
      },
    });
  } else {
    $prerequisiteAssessmentSelect.html('<option value="">Select an assessment</option>').prop("disabled", true).addClass("disabled");
    $certificationAssessmentSelect.html('<option value="">Select an assessment</option>').prop("disabled", true).addClass("disabled");
    $settingsSelect.html('<option value="">Select a configuration</option>').prop("disabled", true).addClass("disabled");
  }
}

// Handle diocese select change (for Ark Admin)
$(document).on("change", "#diocese_select", function () {
  const dioceseId = $(this).val();
  loadRelatedData(dioceseId);
});

// Function to enable all select fields
function enableSelectFields() {
  const $prerequisiteSelect = $("#prerequisite_assessment_select");
  const $certificationSelect = $("#certification_assessment_select");  
  const $settingsSelect = $("#settings_select");
  
  $prerequisiteSelect.prop("disabled", false).removeClass("disabled");
  $certificationSelect.prop("disabled", false).removeClass("disabled");
  $settingsSelect.prop("disabled", false).removeClass("disabled");
  
  console.log('All select fields enabled');
}

// Auto-load data for non-Ark Admin users (Diocese Executive/Admin)
$(document).ready(function() {
  // Use setTimeout to ensure DOM is fully loaded
  setTimeout(function() {
    const $dioceseSelect = $("#diocese_select");
    const $hiddenDiocese = $("input[name='pcc_assessment[diocese_id]'][type='hidden']");
    
    // Check if we're in edit mode by looking at existing select options
    const $prerequisiteSelect = $("#prerequisite_assessment_select");
    const $certificationSelect = $("#certification_assessment_select");  
    const $settingsSelect = $("#settings_select");
    
    const hasExistingData = $prerequisiteSelect.find('option[value!=""]').length > 0 ||
                           $certificationSelect.find('option[value!=""]').length > 0 ||
                           $settingsSelect.find('option[value!=""]').length > 0;
    
    console.log('Form initialization - hasExistingData:', hasExistingData);
    
    if ($hiddenDiocese.length > 0) {
      // Diocese Executive/Admin - they have a hidden diocese field
      const dioceseId = $hiddenDiocese.val();
      console.log('Diocese Executive detected, dioceseId:', dioceseId);
      
      if (dioceseId) {
        if (hasExistingData) {
          // Data already loaded from server - just enable the fields
          console.log('Data already loaded from server for Diocese Executive, enabling fields');
          enableSelectFields();
        } else {
          // No data loaded from server - load via AJAX
          console.log('Loading data via AJAX for Diocese Executive');
          loadRelatedData(dioceseId);
        }
      }
    } else if ($dioceseSelect.length > 0) {
      // Ark Admin
      console.log('Ark Admin detected');
      const selectedDiocese = $dioceseSelect.val();
      
      if (selectedDiocese && hasExistingData) {
        // Edit mode with existing data
        console.log('Edit mode for Ark Admin, enabling fields');
        enableSelectFields();
      } else if (selectedDiocese && !hasExistingData) {
        // Edit mode but no data loaded yet
        console.log('Ark Admin with selected diocese, loading data');
        loadRelatedData(selectedDiocese);
      }
    }
    
    // Force enable all fields if they have any options (safety net)
    if (hasExistingData) {
      enableSelectFields();
    }
  }, 100); // Small delay to ensure DOM is ready
});
